var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 12.3799C22.1667 17.8999 17.6867 22.3799 12.1667 22.3799C6.64675 22.3799 2.16675 17.8999 2.16675 12.3799C2.16675 6.85988 6.64675 2.37988 12.1667 2.37988C17.6867 2.37988 22.1667 6.85988 22.1667 12.3799Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8766 15.5596L12.7766 13.7096C12.2366 13.3896 11.7966 12.6196 11.7966 11.9896V7.88965",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.691f8cedb1aaa8772b0390ea7f7061c4.svg";
export { ForwardRef as ReactComponent };